//import Vuex from 'vuex';
import {createStore} from 'vuex';
// затягиваем из umd, так как esm билд конфликтует с uglify
import VuexPersist from 'vuex-persist/dist/umd';
import settings from './modules/settings.js';
import user from './modules/user.js';
import descriptions from './modules/descriptions.js';
import notifications from './modules/notifications.js';
import localStorageKey from './localStorageKey.js';

//app.use(Vuex);

const isDev = process.env.NODE_ENV !== 'production';

const vuexPersist = new VuexPersist({
  key: localStorageKey,
  storage: window.localStorage,
});

const store = createStore({
  modules: {
    settings,
    user,
    descriptions,
    notifications,
  },
  strict: isDev,
  plugins: [vuexPersist.plugin],
});

export default store;
